import { updateHistoryQuery, addNewHistoryQuery } from '../../actions/ioc';
import { MessageType } from '../../constants/websocketMessageTypes';
import {
  setWebsocketConnection,
  setWebsocketConnectionStatus,
} from '../../actions/user';
import { STATUS } from '../../constants';
import store from '../../store';

const handleUpdatedQueryMessage = (data) => {
  const uuid = data?.query_uuid;
  const status = data?.status;
  const total_results = data?.total_results;
  store?.dispatch(updateHistoryQuery(uuid, status, total_results));
};

const handleNewQueryMessage = (data) => {
  const uuid = data?.uuid;
  const url = data?.url;
  const origin_label = data?.origin_label;
  const origin_uid = data?.origin_uid;
  const job_id = data?.job_id;
  const total_results = data?.total_results;
  const status = data?.status;
  const is_enabled = data?.is_enabled;
  const is_visualizable = data?.is_visualizable;
  const created = data?.created;
  const executed_by = data?.executed_by;
  store?.dispatch(
    addNewHistoryQuery(
      uuid,
      url,
      origin_label,
      origin_uid,
      job_id,
      total_results,
      status,
      is_enabled,
      is_visualizable,
      created,
      executed_by,
    ),
  );
};

const checkIfToCloseConnection = (webSocketConnection) => {
  const state = store?.getState();
  const { token } = state?.auth;
  if (token === '' || token === undefined || token === null) {
    webSocketConnection.close();
    return true;
  }
  return false;
};

export const startWebSocketConnection = () => {
  const state = store?.getState();
  const { token } = state?.auth;
  const ws_url = process.env.REACT_APP_WEBSOCKET_URL;
  if (token && ws_url) {
    const host = new URL(process.env.REACT_APP_WEBSOCKET_URL);
    store?.dispatch(setWebsocketConnectionStatus(WebSocket.CONNECTING));
    const webSocketConnection = new WebSocket(host + 'ws/sp');
    webSocketConnection.onopen = () => {
      // alert('open');
      if (!checkIfToCloseConnection(webSocketConnection)) {
        store?.dispatch(setWebsocketConnectionStatus(WebSocket.OPEN));
        webSocketConnection.send(
          JSON.stringify({
            type: MessageType.AUTHENTICATE,
            token: token,
          }),
        );
      }
    };
    webSocketConnection.onerror = (error) => {
      console.log('WebSocket error ' + error);
    };
    webSocketConnection.onclose = () => {
      store?.dispatch(setWebsocketConnectionStatus(WebSocket.CLOSED));
      store?.dispatch(setWebsocketConnection(null));
    };
    webSocketConnection.onmessage = (data) => {
      const message = JSON.parse(data.data);
      const type = message?.type;
      // any new message type should be handled here
      if (type === MessageType.AUTHENTICATION_DONE) {
        if (!checkIfToCloseConnection(webSocketConnection)) {
          store?.dispatch(setWebsocketConnection(webSocketConnection));
          store?.dispatch(setWebsocketConnectionStatus(WebSocket.OPEN));
        }
      } else if (type === MessageType.QUERY_UPDATED) {
        handleUpdatedQueryMessage(message?.data);
      } else if (type === MessageType.QUERY_CREATED) {
        handleNewQueryMessage(message?.data);
      }
    };
  }
};
